import { figmaColors } from '@doltech/ui/lib/figma/colors';
import { FontSizeSwitcherPlugin } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/FontSizeSwitcherPlugin';
import { FontSizeModeEnum } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/types';
import { DolEditor } from '@doltech/ui/lib/figma/DolEditor/DolEditor';
import { HighlightPlugin } from '@doltech/ui/lib/slatePlugins/marks/highlight/HighlightPlugin';
import * as React from 'react';
import styled from 'styled-components';

import { NoteElementPlugin } from '@doltech/ui/lib/figma/DolEditor/elements/note/plugin';
import { withInlineVoid } from '@doltech/ui/lib/slatePlugins/plugins/inline-void/withInlineVoid';
import { ToolbarDoingTest } from './toolbar/ToolbarDoingTest';

interface EditorDoingTestProps {
  width?: string;
  withToolBar?: boolean;
  selectionOnly?: boolean;
  initialValue?: any;
  onChange?: (editorValue: string) => void;
  id?: string;
}

const Main = styled.div<EditorDoingTestProps>`
  padding-right: 16px;
  .btn-back {
    cursor: pointer;
    font-size: 16px;
    margin-bottom: 10px;
    .sub-text {
      margin-left: 8px;
      color: ${figmaColors.text1};
    }
    &:hover {
      .sub-text {
        color: ${figmaColors.neutral9};
      }
    }
  }

  .editor-doing-test {
    font-family: Inter, sans-serif;
  }
`;

export const EditorDoingTest = (props: EditorDoingTestProps) => {
  const { selectionOnly, withToolBar, onChange, initialValue, ...rest } = props;
  const [fontSizeMode, setFontSizeMode] = React.useState(FontSizeModeEnum.DEFAULT);
  const plugins = [HighlightPlugin(), NoteElementPlugin()];

  return (
    <Main {...rest}>
      <div className="content">
        <DolEditor
          readOnly
          className="editor-doing-test"
          plugins={[...plugins, ...[FontSizeSwitcherPlugin(FontSizeModeEnum.DEFAULT)]]}
          onEditorChange={(changeValue, _) => {
            onChange?.(JSON.stringify(changeValue));
          }}
          initialValue={initialValue}
          withToolbar={
            <ToolbarDoingTest fontSizeMode={fontSizeMode} setFontSizeMode={setFontSizeMode} />
          }
          editorChains={[withInlineVoid({ plugins })]}
          onDragStart={(event) => {
            event.preventDefault();
          }}
        />
      </div>
    </Main>
  );
};
